import Dexie from "dexie";
import db from "../Db";

var DeleteMateriau = Dexie.async(function* () {
  yield db.open();
  yield db.MATERIAU.clear();
});

export default DeleteMateriau;
